import React, { useEffect, useState } from 'react';
import PlantillaScreen from '../../../helpers/PlantillaScreen';
import { LoaderScreen } from '../../../components/LoaderScreen';
import request from '../../../../Helpers/API';
import Swal from 'sweetalert2';
import { useParams } from "react-router-dom";
import DeleteIcon from '@mui/icons-material/Delete';
import { ButtonBack } from '../Util/ButtonBack';
import { SearchSelect } from '../../ConfigurarLeads/SearchSelect';

export const CatSalaResponsablesScreen = () => {

    const { id } = useParams();

    const [nombreSala, setNombreSala] = useState("");
    const [empleados, setEmpleados] = useState([]);
    const [responsables, setResponsables] = useState([]);
    const [idEmpleadoSeleccionado, setIdEmpleadoSeleccionado] = useState(null);
    const [loader, setLoader] = useState({ mostrar: false });

    useEffect(() => {
        request.get("SalaResponsable/EmpleadosDropDown")
            .then(res => setEmpleados(res || []))
            .catch(() => Swal.fire("ERROR", "No se pudieron cargar los empleados", "error"));
    }, []);

    useEffect(() => {
        request.get(`Sala/Obtener/${id}`)
            .then(result => setNombreSala(result.nombresala))
            .catch(() => Swal.fire("ERROR", "No se pudo obtener la sala", "error"));
    }, [id]);

    useEffect(() => {
        if (id) cargarResponsables();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const cargarResponsables = () => {
        setLoader({ mostrar: true });
        request.get(`SalaResponsable/Listado/${id}`)
            .then(result => {
                const responsablesNormalizados = (result || [])
                    .filter(r => r.estado) // solo activos
                    .map(r => ({
                        ...r,
                        IDEmpleado: r.IDEmpleado || r.idEmpleado || r.id,
                        IDEmpleadoBackend: r.idRelSalaResponsable || r.idRel || r.id
                    }));

                setResponsables(responsablesNormalizados);
            })
            .catch(() => setResponsables([]))
            .finally(() => setLoader({ mostrar: false }));
    };

    const onAgregarResponsable = () => {
        if (!idEmpleadoSeleccionado) {
            Swal.fire("RESPONSABLES", "Seleccione un empleado", "warning");
            return;
        }

        if (responsables.find(r => r.IDEmpleado === idEmpleadoSeleccionado)) {
            Swal.fire("RESPONSABLES", "El empleado ya fue agregado", "warning");
            return;
        }

        const nuevoResponsable = {
            idRelSalaResponsable: -999,
            idSala: parseInt(id),
            IDEmpleado: idEmpleadoSeleccionado,
            usuario: 1,
            estado: true
        };

        request.post("SalaResponsable/Guardar", nuevoResponsable)
            .then(() => {
                Swal.fire("OK", "Responsable agregado correctamente", "success");
                setIdEmpleadoSeleccionado(null);
                cargarResponsables();
            })
            .catch(err => {
                Swal.fire("ERROR", err?.response?.data?.mensaje || JSON.stringify(err?.response?.data), "error");
            });
    };

    const onEliminar = (idRelSalaResponsable, nombreCompleto) => {
        Swal.fire({
            title: '¿Está seguro?',
            text: `Se eliminará al responsable: ${nombreCompleto}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                request.post("SalaResponsable/EliminarPorID", {
                    IdRelSalaResponsable: idRelSalaResponsable,
                    idSala: parseInt(id)
                })
                    .then(() => {
                        Swal.fire("OK", "Responsable eliminado", "success");
                        cargarResponsables();
                    })
                    .catch(err => {
                        Swal.fire("ERROR", err?.response?.data?.mensaje || "No se pudo eliminar", "error");
                    });
            }
        });
    };

    return (
        <PlantillaScreen
            titulo={"RELACIÓN DE RESPONSABLES"}
            className_main={1}
            className={"seguimiento-actividades-contenedor"}
        >
            <LoaderScreen loader={loader} />

            <div className="nsi-contenido nsi-contenido--full">

                <div className="nsi-rol-aviso">
                    <span className="nsi-rol-aviso-badge">SALA</span>
                    {nombreSala || "Cargando..."}
                </div>

                <div className="nsi-card">
                    <div className="nsi-card-header">
                        <span className="nsi-card-header-numero">1</span>
                        <div>
                            <div className="nsi-card-header-titulo">Agregar responsable</div>
                            <div className="nsi-card-header-subtitulo">Elige un empleado para asignarlo a esta sala</div>
                        </div>
                    </div>

                    <div className="lead-form-group">
                        <label>Empleado</label>
                        <div className="csce-opciones-input">
                            <SearchSelect
                                options={empleados.map((e) => ({
                                    value: e.IDEmpleado,
                                    label: `${e.Nombre} ${e.ApellidoPaterno} ${e.ApellidoMaterno}`,
                                }))}
                                value={idEmpleadoSeleccionado}
                                onChange={setIdEmpleadoSeleccionado}
                                placeholder="Seleccione un empleado"
                            />
                            <button type="button" onClick={onAgregarResponsable}>
                                Agregar
                            </button>
                        </div>
                    </div>
                </div>

                <div className="nsi-card">
                    <div className="nsi-card-header">
                        <span className="nsi-card-header-numero">2</span>
                        <div>
                            <div className="nsi-card-header-titulo">Responsables asignados</div>
                            <div className="nsi-card-header-subtitulo">
                                {responsables.length} {responsables.length === 1 ? "responsable" : "responsables"}
                            </div>
                        </div>
                    </div>

                    {responsables.length === 0 ? (
                        <div className="csce-vacio">No hay responsables agregados todavía</div>
                    ) : (
                        <div className="sacc-tabla sacc-tabla-responsables sacc-tabla--compacta scroll">
                            <table className='sacct-container'>
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>NOMBRE</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {responsables.map(r => (
                                        <tr key={r.IDEmpleado}>
                                            <td><span className="sacct-id-chip">{r.IDEmpleado}</span></td>
                                            <td>{r.nombreCompleto}</td>
                                            <td className='sa-eliminar' align="center">
                                                <button
                                                    type="button"
                                                    className='button-eliminar'
                                                    onClick={() => onEliminar(r.IDEmpleadoBackend, r.nombreCompleto)}
                                                >
                                                    <DeleteIcon />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>

            </div>

            <ButtonBack path={"/Permisos/CatalogoSala"} />
        </PlantillaScreen>
    );
};
